import styles from "./OverviewSubTab.module.scss"

type Salon = {
	salonId: number
	salonName: string
}

type Props = {
	salons: Salon[]
}

const SalonListSection = ({ salons }: Props) => {
	const sortedSalons = [...salons].sort((a, b) => a.salonId - b.salonId)

	return (
		<div className={styles.section}>
			<h3 className={styles.section_title}>所属店舗一覧</h3>
			{sortedSalons.length === 0 ? (
				<p className={styles.empty_text}>所属店舗はありません</p>
			) : (
				<ul className={styles.salon_list}>
					{sortedSalons.map((salon) => (
						<li key={salon.salonId} className={styles.salon_item}>
							{salon.salonName}
						</li>
					))}
				</ul>
			)}
		</div>
	)
}

export default SalonListSection
